/* @ngInject */
const wagonWritter = (
  excelUtils,
  parkOptions,
  unparkOptions,
  readinessOptions,
  sortOptions,
  listOptions,
  dispositionOptions,
  bulletinFreinageOptions,
  compositionOptions,
  scrappingOptions,
  matcher,
  $filter
) => {
  const self = {}

  const ADDITIONAL_OWNER_SHEET = 15

  const defaultOptions = {
    title: 'Mon document',
    data: [],
    sortOrder: ['area', 'railway', 'position',],
    rowHeight: 15,
  }

  self.download = (name, wagons, options) => {
    return self.generate(name, wagons, options)
      .then((blob) => { excelUtils.downloadWorkbook(blob, options.title) })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.generate = (name, wagons, options) => {
    options = self.getOptions(name, options)

    return excelUtils.getWorkbook(options.filename)
      .then((workbook) => {
        const sheet = workbook.sheet(0)
        sheet.active(true)
        wagons = $filter('orderBy')(wagons, options.sortOrder)

        self.writeHeader(sheet, options)
        self.writeSheet(sheet, wagons, options)

        if (options.enableOwnerSheet) {
          const owners = excelUtils.getOwnersOf(wagons)
          if (options.disableOwnerColor) options.enableColor = false
          for (let ownerIndex = 0; ownerIndex < Math.min(owners.length, ADDITIONAL_OWNER_SHEET); ownerIndex++) {
            const owner = owners[ownerIndex]
            const ownerSheet = workbook.sheet(ownerIndex + 1)
            options.owner = owner
            ownerSheet.name(owner.toString())

            self.writeHeader(ownerSheet, options)
            self.writeSheet(ownerSheet, wagons, options)
          }
          for (let i = ADDITIONAL_OWNER_SHEET; i > owners.length; i--) {
            workbook.deleteSheet(i)
          }
        }

        if (options.filename === 'bulletinFreinage' || options.filename === 'compositionTrain') {
          const sheet = workbook.sheet(options.secondSheet)
          options.getBodyCells2(options, wagons).forEach((cellInfo) => {
            excelUtils.setCell(sheet, cellInfo, cellInfo.style || options.style2)
          })
        }

        return workbook.outputAsync({ type: '', })
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.writeHeader = (sheet, options) => {
    if (!options.getHeaderCells) return
    options.getHeaderCells(options.train).forEach((cellInfo) => {
      excelUtils.setCell(sheet, cellInfo)
    })
  }

  self.writeSheet = (sheet, wagons, options) => {
    const sheetId = sheet._idNode.attributes['r:id']
    let rowIndex = options.firstRow
    for (let wagonIndex = 0; wagonIndex < wagons.length; wagonIndex++) {
      const wagon = wagons[wagonIndex]
      options.currentRow = rowIndex
      if (!options.enableOwnerSheet || wagon.owner === options.owner || sheetId === 'rId1') {
        self.writeRow(sheet, wagon, options)
        rowIndex++
      }
    }
  }

  self.writeRow = (sheet, wagon, options) => {
    sheet.row(options.currentRow).height(18)
    options.getBodyCells(options, wagon).forEach((cellInfo) => {
      excelUtils.setCell(sheet, cellInfo, options.style)
      excelUtils.setCellHeight(sheet, cellInfo.name, cellInfo.value)
      const cell = sheet.cell(cellInfo.name)
      if (options.enableColor) {
        excelUtils.setColorStyles(cell, wagon, cellInfo.ref)
      }
      excelUtils.setColorId(cell, wagon, cellInfo.ref)
    })
  }

  self.getOptions = (name, options = {}) => {
    if (matcher.contain(name, 'unpark|Unpark')) {
      return unparkOptions.generateOptions(options)
    } else if (matcher.contain(name, 'park|Park')) {
      return parkOptions.generateOptions(options)
    } else if (matcher.contain(name, 'dispo|Dispo')) {
      return dispositionOptions.generateOptions(options)
    } else if (matcher.contain(name, 'readi|Readi')) {
      return readinessOptions.generateOptions(options)
    } else if (matcher.contain(name, 'sort|Sort')) {
      return sortOptions.generateOptions(options)
    } else if (matcher.contain(name, 'list|List')) {
      return listOptions.generateOptions(options)
    } else if (matcher.contain(name, 'scrapping|Scrapping')) {
      return scrappingOptions.generateOptions(options)
    } else if (matcher.contain(name, 'bulletin|Bulletin')) {
      return bulletinFreinageOptions.generateOptions(options)
    } else if (matcher.contain(name, 'composition|Composition')) {
      return compositionOptions.generateOptions(options)
    } else {
      return defaultOptions
    }
  }

  return self
}
export default wagonWritter



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/wagon/wagonExcel.service.js